export default class DealerError extends Error {}
